
export class MonthItem {
  constructor(
    monthName: string,
    monthNumber: number,
    monthCssClass: string,
    monthSummaryName: string
  ) {
    this.monthName = monthName;
    this.monthNumber = monthNumber;
    this.monthCssClass = monthCssClass;
    this.monthSummaryName = monthSummaryName;
  }
  public monthName: string;
  public monthNumber: number;
  public monthCssClass:string;
  public monthSummaryName: string;
  public inputValue?:number;
  public outputValue?:number;
}
